import React, { useState, useEffect } from "react";
import { BsCalendar4Event, BsGraphUpArrow } from "react-icons/bs";
import { CiPause1 } from "react-icons/ci";
import { SlLocationPin } from "react-icons/sl";
import { militaryLogo } from "../../assets/constant";
import useClickOutside from "../../customHooks/useClickOutside";
import PopperMedicineTarget from "../AllPoppers/Medicine/PopperMedicineTarget";
import PopperMedicineEstimateTarget from "../AllPoppers/MedicineEstimatedValue";
import CollapsableSearch from "../CollapsableSearch";
import CommonCard from "../CommonCard";
import DateRangeCalendar from "../DateRangeSelector";
import { Dropdown } from "../Dropdown";
import FilterActionButton from "../FilterActionButton";
import PopperMenu from "../PopperMenu";
// import PopupContainer from "../PopupContainer";
import classes from "./TableHeaderFilter.module.css";
import PopoverTrigger from "../PopoverTrigger";
import { BsSearch } from "react-icons/bs";
import { Input } from "../Input";
import Button from "../Button";
import { MilitaryIcon } from "../../assets/Icon";
import { useSelector, useDispatch } from "react-redux";
import { getLocationsForDropdown } from "../../store/features/location/locationSelector";
import CollapsibleDropdown from "../CollapsibleDropdown";


const lists = ["All", "Acheived", "Not Acheived"];
const allLimits = [10, 20, 30, 50];


const TableHeaderFilter = ({
  label,
  tableFields,
  filterActions,
  handler,
  decideFilterActions = {
    calender: true,
    mainSearch: true,
    achieved: true,
    target: true,
    locationSearch: true,
    customTarget: true,
  },
}) => {


  const dispatch = useDispatch();

  //Table Filters
  const [search, setSearch] = useState("");
  const [debounceSearch, setDebounceSearch] = useState("");
  const [maxTarget, setMaxTarget] = useState(0);
  const [minTarget, setMinTarget] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [minValue, setMinValue] = useState(0);
  const [filterBystatus, setFilterBystatus] = useState("");
  const [filterByLocation, setFilterByLocation] = useState({ value: 0, label: "All Locations" });


  const {
    // search,
    // setSearch,
    // limit,
    // setLimit,
    // maxTarget,
    // setMaxTarget,
    // minTarget,
    // setMinTarget,
    // minValue,
    // setMinValue,
    // maxValue,
    // setMaxValue,
    // filterBystatus,
    // setFilterBystatus = () => { },
    // filterByLocation,
    // setFilterByLocation,
  } = filterActions;

  const {
    calender,
    mainSearch,
    achieved,
    target,
    locationSearch,
    customTarget,
  } = decideFilterActions;


  const [limitVal, setLimitVal] = useState(0);
  const [pointedEle, setPointedEle] = useState(null);
  const locationOptions = useSelector(getLocationsForDropdown);


  const openLimitHandler = (event) => {
    setPointedEle(event?.target?.value);
  };

  const updatedLocationList = [{ label: "All Locations", value: 0 }, ...locationOptions?.map((item) => {
    return { label: item.locationName, value: item.locationId };
  })] || [];

  useEffect(() => {
    const effect = setTimeout(() => {
      setDebounceSearch(search);
    }, 300);
    return () => clearTimeout(effect);
  }, [search]);

  useEffect(() => {
    const filters = {
      locationId: filterByLocation?.value,
      targetStatus: filterBystatus,
      targetFilter: {
        minValue: minTarget,
        maxValue: maxTarget
      },
      estimatedFilter: {
        minValue: minValue,
        maxValue: maxValue
      },
      search: debounceSearch,
    }
    handler(filters);
  }, [debounceSearch, maxTarget, minTarget, minValue, maxValue, filterBystatus, filterByLocation]);

  return (
    <div className={classes["table__header"]}>
      <h2 className={classes["table__title"]}>{label}</h2>
      <ul className={[classes["filter__actionWrapper"]].join(" ")}>
        {mainSearch && (
          <li>
            <Input
              customStyle={{
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
              }}
              inputStyle={{
                paddingLeft: "0px",
                paddingBlock: "6px",
                maxWidth: "178px",
              }}
              parentCustomStyle={{ flex: 1, borderRadius: "6px" }}
              setter={setSearch}
              value={search}
              placeholder={"Search Here ...."}
              leftIcon={
                <Button
                  style={{ marginLeft: "-10px", cursor: "pointer" }}
                  className="button_transparent p-0"
                  onClick={() => { }}
                >
                  <BsSearch color="var(--medium-gray)" />
                </Button>
              }
            />
          </li>
        )}
        {calender && (
          <li style={{ position: "relative" }}>
            <PopperMenu
              component={<DateRangeCalendar />}
              listStyle={{ right: "50%", top: "50px" }}

              setter={() => { }}
            >
              <FilterActionButton
                className={classes.iconHolder}
                label={<BsCalendar4Event />}
              />
            </PopperMenu>
            {/* <FilterActionButton
              className={classes.iconHolder}
              ref={calenderRef}
              onClick={() => {
                setShowCalender && setShowCalender(true);
              }}
            >
            
              <BsCalendar4Event />
            </FilterActionButton>
            <PopupContainer show={showCalender} setShow={setShowCalender}>
              <DateRangeCalendar />
            </PopupContainer> */}
          </li>
        )}
        {/* <li>
          <CollapsableSearch
            search={search}
            setSearch={setSearch}
            icon={<BsCalendar4Event />}
          />
        </li> */}
        {locationSearch && (
          <li>
            <CollapsibleDropdown value={filterByLocation} setter={setFilterByLocation} options={updatedLocationList} />
          </li>
        )}
        {target && (
          <li style={{ position: "relative" }}>
            <PopperMedicineTarget
              minValue={minValue}
              setMinValue={setMinValue}
              maxValue={maxValue}
              setMaxValue={setMaxValue} />
          </li>
        )}
        {customTarget && (
          <li style={{ position: "relative" }}>
            <PopperMedicineEstimateTarget
              minTarget={minTarget}
              setMinTarget={setMinTarget}
              maxTarget={maxTarget}
              setMaxTarget={setMaxTarget}
            />
          </li>
        )}
        {achieved && (
          <li>
            <PopperMenu lists={lists} setter={setFilterBystatus}>
              <FilterActionButton className={classes.iconHolder}>
                <MilitaryIcon />
                {/* <img
                  src={militaryLogo}
                  className={classes.militaryImg}
                  alt="military logo"
                /> */}
              </FilterActionButton>
            </PopperMenu>
          </li>
        )}
      </ul>

      <div className={classes["show-pages-and-colummns"]}>
        <p className={classes.pageIndicator}>Results per page</p>
        {/* <CommonCard className={classes.pageValue__wrapper}>
          <Dropdown
            style={{ height: "34px", width: "34px" }}
            setter={setLimit}
            value={limit}
            optionsWidth="fit-content"
            dropdownIndicator={false}
            placeholder={""}
            options={[
              { label: 10, value: "10" },
              { label: 30, value: "30" },
              { label: 60, value: "60" },
            ]}
            customStyle={{ padding: "0px", width: "32px" }}
          />
        </CommonCard> */}
        <div
          aria-describedby={"doctor-limit"}
          variant="contained"
          className={classes.limitInput}
          onClick={(event) => {
            setPointedEle(event.currentTarget);
          }}
        >
          {limitVal}
        </div>
        <PopoverTrigger
          isIcon={false}
          lists={allLimits}
          setter={setLimitVal}
          onClick={() => { }}
          anchorEle={pointedEle}
          setAnchorEle={setPointedEle}
        />
        <PopperMenu
          listStyle={{ right: "50%", top: "50px" }}
          lists={tableFields}
          setter={() => { }}
        >
          <FilterActionButton
            className={classes.iconHolder}
            label={<CiPause1 size={20} color="var(--medium-gray)" />}
          />
        </PopperMenu>
      </div>
    </div>
  );
};

export default TableHeaderFilter;
